import React, { Suspense } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { LayoutSplashScreen, ContentRoute } from '../_metronic/layout';
// import { BuilderPage } from './pages/BuilderPage';
// import { MyPage } from './pages/MyPage';
import { DashboardPage } from './pages/DashboardPage';
import SettingsPage from './modules/Settings/SettingsPage';
import CustomerPage from './modules/Customers/CustomerPage';
import SupplierPage from './modules/Suppliers/SupplierPage';
import { ProductsPage } from './modules/Equipments/products/ProductsPage';
import { ProductEdit } from './modules/Equipments/products/product-edit/ProductEdit';
import PayablePage from './modules/Payable/PayablePage';
import ReceivablePage from './modules/Receivable/ReceivablePage';
// const GoogleMaterialPage = lazy(() =>
//   import('./modules/GoogleMaterialExamples/GoogleMaterialPage')
// );
// const ReactBootstrapPage = lazy(() =>
//   import('./modules/ReactBootstrapExamples/ReactBootstrapPage')
// );
// const ECommercePage = lazy(() =>
//   import('./modules/ECommerce/pages/eCommercePage')
// );
// const UserProfilepage = lazy(() =>
//   import('./modules/UserProfile/UserProfilePage')
// );

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        {/* <ContentRoute path="/builder" component={BuilderPage} /> */}
        {/* <ContentRoute path="/my-page" component={MyPage} /> */}
        <Route path="/settings" component={SettingsPage} />
        <Route path="/customers" component={CustomerPage} />
        <Route path="/suppliers" component={SupplierPage} />
        <Route path="/payables" component={PayablePage} />
        <Route path="/receivables" component={ReceivablePage} />
        <Route path="/products/:id/edit" component={ProductEdit} />
        <Route path="/products/new" component={ProductEdit} />
        <Route path="/products" component={ProductsPage} />
        {/* <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} /> */}
        {/* <Route path="/e-commerce" component={ECommercePage} /> */}
        {/* <Route path="/user-profile" component={UserProfilepage} /> */}
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
